import { GridColumn } from 'src/components/GridWrapper';
import ActionRequiredAmountField from 'src/sections/action_required_invoices/ActionRequiredAmountField';
import DocumentField from 'src/sections/action_required_invoices/actionRequiredColumns/DocumentField';
import GLCodeMismatchField from 'src/sections/action_required_invoices/actionRequiredColumns/GLCodeMismatchField';
import GLSummaryInfoField from 'src/sections/action_required_invoices/actionRequiredColumns/GLSummaryInfoField';
import POItemsCompleteField from 'src/sections/action_required_invoices/actionRequiredColumns/POItemsCompleteField';
import PercentRecField from 'src/sections/action_required_invoices/actionRequiredColumns/PercentRecField';
import StatusFilesField from 'src/sections/action_required_invoices/actionRequiredColumns/StatusFilesField';

export const ActionRequiredColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    filter: 'text',
    width: '30px',
    format: '',
    menu: false,
  },
  {
    field: 'invoiceOverCreatorLimit',
    title: 'Status',
    format: '',
    component: StatusFilesField,
    width: '150px',
    menu: false,
    minResizableWidth: 150,
  },
  {
    field: 'invoiceNumber',
    title: 'Document #',
    filter: 'text',
    component: DocumentField,
    width: '120px',
  },
  {
    field: 'invoiceDate',
    title: 'Invoice Date',
    filter: 'date',
    format: '{0:MM/dd/yyyy}',
    dataType: 'date',
    width: '130px',
  },
  {
    field: 'totalCostAmt',
    title: 'Document Total',
    filter: 'numeric',
    format: '{0:c2}',
    component: ActionRequiredAmountField,
    width: '130px',
    dataType: 'fixed',
    filterFormat: 'c2',
  },
  {
    field: 'poTotal',
    title: 'PO Total',
    filter: 'numeric',
    format: '{0:c2}',
    component: ActionRequiredAmountField,
    width: '110px',
    dataType: 'fixed',
    filterFormat: 'c2',
  },
  {
    field: 'percentRecvByQuantity',
    title: '% Rec (by Qty)',
    filter: 'numeric',
    format: '',
    component: PercentRecField,
    width: '130px',
    dataType: 'fixed',
    filterFormat: 'p2',
    step: 0.01,
  },
  {
    field: 'percentRecvByDollar',
    title: '% Rec (by $)',
    filter: 'numeric',
    format: '',
    component: PercentRecField,
    width: '130px',
    filterFormat: 'p2',
    step: 0.01,
  },

  {
    field: 'hasGlMismatchItems',
    title: 'GL Code Mismatch',
    component: GLCodeMismatchField,
    filter: 'boolean',
    dataType: 'fixed',
    width: '130px',
  },
  {
    field: 'poItemsCompleted',
    title: 'PO Items Complete',
    component: POItemsCompleteField,
    filter: 'boolean',
    dataType: 'fixed',
    width: '130px',
  },
  {
    field: 'glSummaries',
    component: GLSummaryInfoField,
    title: 'GL Summary',
    width: '90px',
    menu: false,
    sortable: false,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    filter: 'text',
    format: '',
    width: '130px',
  },
  {
    field: 'buyerName',
    title: 'Buyer Name',
    filter: 'text',
    format: '',
    width: '125px',
  },
  {
    field: 'supplierName',
    title: 'Supplier Name',
    filter: 'text',
    format: '',
    width: '125px',
  },
];
